/**
 * LetterNavigation Component
 * A-Z navigation strip with sticky positioning
 */

import React from "react";
import type { Language } from "../types";

interface LetterNavigationProps {
  letters: string[];
  activeLetter: string | null;
  letterCounts: Record<string, number>;
  onSelect: (letter: string | null) => void;
  language: Language;
}

const LetterNavigation: React.FC<LetterNavigationProps> = ({
  letters,
  activeLetter,
  letterCounts,
  onSelect,
  language,
}) => {
  const allLabel = language === "cs" ? "Vše" : "All";

  return (
    <nav className="letter-nav" aria-label="Alphabetical navigation">
      <div className="letter-nav-inner">
        {/* All button */}
        <button
          className={`letter-btn ${activeLetter === null ? "active" : ""}`}
          onClick={() => onSelect(null)}
          aria-label={allLabel}
        >
          {allLabel}
        </button>

        {/* Letter buttons */}
        {letters.map((letter) => {
          const count = letterCounts[letter] || 0;
          const isActive = activeLetter === letter;
          const isDisabled = count === 0;

          return (
            <button
              key={letter}
              className={`letter-btn ${isActive ? "active" : ""} ${isDisabled ? "disabled" : ""}`}
              onClick={() => !isDisabled && onSelect(letter)}
              disabled={isDisabled}
              aria-label={`${letter} (${count} ${language === "cs" ? "pojmů" : "terms"})`}
              aria-pressed={isActive}
            >
              {letter}
              {count > 0 && !isActive && (
                <span className="letter-count">{count}</span>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default LetterNavigation;
